import ProductCard from "./ProductCard";

export default function ProductsList({
  productsList = [],
  viewProduct,
  productsRef,
  addItemtoCart,
  removeItemtoCart,
  cartList,
  addItemtoWishlist,
  removeItemtoWishlist,
  wishList,
}) {
  return (
    <section
      className="section-deal padding-tb-50"
      ref={productsRef}
      id="products"
    >
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <div className="section-title bb-deal">
              <div className="section-detail text-center">
                <h2 className="bb-title">
                 <span> Korean </span> Skincare Products
                </h2>
                <p>Don't wait. The time will never be just right.</p>
              </div>
              {/* <div id="dealend" class="dealend-timer"></div> */}
            </div>
          </div>

          <div className="col-12">
            <div className="row g-3">
              {productsList.map((product,index) => (
                <div className="col-12 col-sm-6 col-lg-4" key={product._id}>
                  <ProductCard
                    viewProduct={viewProduct}
                    product={product}
                    addItemtoCart={addItemtoCart}
                    removeItemtoCart={removeItemtoCart}
                    cartList={cartList}
                    addItemtoWishlist={addItemtoWishlist}
                    removeItemtoWishlist={removeItemtoWishlist}
                    wishList={wishList}
                    index={index}
                  />
                </div>
              ))}
              {productsList.length < 1 && (
                <div
                  style={{
                    minHeight: "400px",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <p>No Items Found!</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
